import { render, staticRenderFns } from "./RenewalEuropeanMobileDetail.vue?vue&type=template&id=36d65b00&scoped=true"
import script from "./RenewalEuropeanMobileDetail.vue?vue&type=script&lang=js"
export * from "./RenewalEuropeanMobileDetail.vue?vue&type=script&lang=js"
import style0 from "./RenewalEuropeanMobileDetail.vue?vue&type=style&index=0&id=36d65b00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d65b00",
  null
  
)

export default component.exports